<template>
    <div class="onboardingContainer">
        <div class="header">
            <div class="heading">
                <img v-if="editMode" class="backArrow" src="../../assets/backArrow.svg" @click="onBackClick"/>
                <p class="title">{{editMode ? 'User Management' : 'Onboarding'}}</p>
            </div>
            <button class="submitBtn" @click="handleSubmit">Submit</button>
        </div>
        <div class="onboardingForm">
            <div v-if="apiErrorMessage" class="errorContainer"> 
                <div class="errorHeading">Error</div>
                <div class="apiErrorMessage">{{ apiErrorMessage }}</div>
            </div>
            <div style="display: flex;">
                <div v-if="!editMode">
                    <div  class="label">Role</div>
                    <select v-model="role" class="role">
                        <option v-for="type in types" v-bind:key="type" :value="type">{{type}}</option>
                    </select>
                </div>
            </div>
            <div class="subHeading">{{role}} Details </div>
            <div class="formContainer">
                <div>
                    <div  class="label">Name</div>
                    <div class="content"> 
                        <input class="textbox" v-model="fields.name" @blur="validateName" placeholder="Enter here" />
                        <p v-if="fieldErrors?.name" class="label" style="color: red">{{fieldErrors.name}}</p>
                    </div>
                </div>
                <div>
                    <div  class="label">Email ID</div>
                    <div class="content"> 
                        <input class="textbox" :disabled="editMode" v-model="fields.email" @blur="validateEmail" placeholder="Enter here" />
                        <p v-if="fieldErrors?.email" class="label" style="color: red">{{fieldErrors.email}}</p>
                    </div>
                </div>
                <div v-if="role == 'Seller' || role == 'Brand'">
                    <div  class="label">{{role}} ID</div>
                    <div class="content"> 
                        <input class="textbox" v-model="fields.userId" @blur="validateUserId" placeholder="Enter here" />
                        <p v-if="fieldErrors?.userId" class="label" style="color: red">{{fieldErrors.userId}}</p>
                    </div>
                </div>
                <div v-if="role == 'Agency'">
                    <div  class="label">Primary Contact Number</div>
                    <div class="content">
                        <span class="countryCode">+91</span>
                        <input style="width: 216px" class="textbox" v-model="fields.primaryContactNumber" @blur="validatePrimaryContact" maxlength="10" placeholder="Enter here" />
                        <p v-if="fieldErrors?.primaryContactNumber" class="label" style="color: red">{{fieldErrors.primaryContactNumber}}</p>
                    </div>
                </div>
                <div v-if="role == 'Agency'">
                    <div  class="label">Secondary Contact Number</div>
                    <div class="content"> 
                        <span class="countryCode">+91</span>
                        <input style="width: 216px" class="textbox" v-model="fields.secondaryContactNumber" @blur="validateSecondaryContact" maxlength="10" placeholder="Enter here" />
                        <p v-if="fieldErrors?.secondaryContactNumber" class="label" style="color: red">{{fieldErrors.secondaryContactNumber}}</p>
                    </div>
                </div>
                <div v-if="role == 'Agency'">
                    <div  class="label">Address</div>
                    <div class="content"> 
                        <textarea class="textbox" style="height: 66px; resize: none" @blur="validateAddress" type="textarea" v-model="fields.address" placeholder="Enter here" />
                        <p v-if="fieldErrors?.address" class="label" style="color: red">{{fieldErrors.address}}</p>
                    </div>
                </div>
                <div v-if="role == 'Agency'">
                    <div  class="label">Pincode</div>
                    <div class="content"> 
                        <input class="textbox" v-model="fields.pincode" maxlength="6" @blur="validatePincode" placeholder="Enter here" />
                        <p v-if="fieldErrors?.pincode" class="label" style="color: red">{{fieldErrors.pincode}}</p>
                    </div>
                </div>
                <div v-if="editMode">
                    <div  class="label">Comments</div>
                    <div class="content"> 
                        <textarea class="comments textarea" placeholder="Enter comments" v-model="fields.comments" />
                    </div>
                </div>
                <p v-if="role === 'Agency'" class="label">
                    Note: The following Documents will be stored and tracked offline for Agency onboarding:IO Doc, Registration Doc, GST Doc, PAN Card, Portfolio Details, Professional Certificate, Cancelled Cheque
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { ROLES } from "@/constants";
import { getCookie, onboardUsers } from "@/services/campaignService";


export default ({
    name: 'Onboarding',
    props: {
        editMode: Boolean,
        item: Object
    },
    data() {
        return {
            types: this.getRoleTypes(),
            role: this.editMode ? 'Agency' : 'Admin',
            fields: {
                name: this.item?.name ?? '',
                email: this.item?.email ?? '',
                userId: this.item?.profileId ?? '',
                primaryContactNumber: this.item?.primaryContactNumber ?? '',
                secondaryContactNumber: this.item?.secondaryContactNumber ?? '',
                address: this.item?.address ?? '',
                pincode: this.item?.pincode ?? '',
                comments: this.item?.comments ?? ''
            },
            fieldErrors: {
                name: '',
                email: '',
                userId: '',
                primaryContactNumber: '',
                secondaryContactNumber: '',
                address: '',
                pincode: '',
            },
            apiErrorMessage: ''
        }
    },
    watch: {
        role(val) {
            this.fieldErrors= {name: '',email: '',userId: '',primaryContactNumber: '',secondaryContactNumber: '',address: '',pincode: ''}
            this.fields= {name: '',email: '',userId: '',primaryContactNumber: '',secondaryContactNumber: '',address: '',pincode: ''}
            this.apiErrorMessage = null
        }
    },
    methods: {
        getRoleTypes() {
            let role = getCookie('role');
            if(role == 'SUPERADMIN') return ROLES;
            else if(role == 'OPS') return ROLES.filter(item => item !== 'Super Admin');
        },
        handleSubmit() {
            if (this.validateForm()) {
                const payload = {
                    sendMail: true,
                    users: [{
                        name: this.fields.name,
                        email: this.fields.email,
                        role: this.role == 'Super Admin' ? 'SUPERADMIN' : this.role == 'Admin' ? 'OPS' : this.role.toUpperCase(),
                        ...((this.role == 'Brand' || this.role == 'Seller') && {userId: this.fields.userId}),
                        ...((this.role == 'Agency') && {primaryContactNumber: this.fields.primaryContactNumber}),
                        ...((this.role == 'Agency') && {secondaryContactNumber: this.fields.secondaryContactNumber}),
                        ...((this.role == 'Agency') && {address: this.fields.address}),
                        ...((this.role == 'Agency') && {pincode: this.fields.pincode}),
                    }]
                }
                onboardUsers(payload)
                    .then(res => res.json())
                    .then(data => {
                        if(data.code == 200) {
                            this.$router.push(`${this.role === 'SUPERADMIN' || this.role === 'OPS' ? '/admin' : ''}/userManagement`);
                            this.onBackClick();
                        } else {
                            this.apiErrorMessage = data?.data || data?.errors?.[0] || data?.message
                        }
                    })
                    .catch(data => {
                        this.apiErrorMessage = data?.data || data?.errors?.[0] || data?.message
                    })
            }
        },
        validateName() {
            this.fieldErrors.name = (this.fields.name == "") ? 'Name cannot be empty' : '';
        },
        validateEmail() {
            const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            this.fieldErrors.email = !emailPattern.test(this.fields.email) ? 'Email is invalid' : '';
        },
        validateUserId() {
            const userIdPattern = /^[0-9]+$/;
            this.fieldErrors.userId = !userIdPattern.test(this.fields.userId) ? 'ID is invalid' : '';
        },
        validatePrimaryContact() {
            const contactPattern = /^[3-9][0-9]{9}$/;
            this.fieldErrors.primaryContactNumber = !contactPattern.test(this.fields.primaryContactNumber) ? 'Number is invalid' : '';
        },
        validateSecondaryContact() {
            const contactPattern = /^[3-9][0-9]{9}$/;
            this.fieldErrors.secondaryContactNumber = !contactPattern.test(this.fields.secondaryContactNumber) ? 'Number is invalid' : '';
        },
        validateAddress() {
            this.fieldErrors.address = (this.fields.address == "") ? 'Address cannot be empty' : '';
        },
        validatePincode() {
            const pattern = /^[0-9]{6}$/;
            this.fieldErrors.pincode = !pattern.test(this.fields.pincode) ? 'Pincode is invalid' : '';
        },
        validateForm() {
            this.validateName();
            this.validateEmail();
            if(this.role == 'Brand' || this.role == 'Seller') {
                this.validateUserId();
                return !this.fieldErrors.userId && !this.fieldErrors.name && !this.fieldErrors.email
            }
            if(this.role == 'Agency') {
                this.validatePrimaryContact();
                this.validateSecondaryContact();
                this.validateAddress();
                this.validatePincode();
                return !this.fieldErrors.primaryContactNumber && !this.fieldErrors.secondaryContactNumber &&
                    !this.fieldErrors.address && !this.fieldErrors.pincode && !this.fieldErrors.name && !this.fieldErrors.email
            }
            if(this.fieldErrors.name || this.fieldErrors.email) return false;
            return true;
        },
        onBackClick() {
            this.$emit('backClicked');
        }
    }
})
</script>

<style scoped>
.onboardingContainer {
    font-family: 'Inter-Regular';
    background: #F8F8F8;
    display: flex;
    flex-direction: column;
}
.header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-family: 'Inter-Regular';
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
    color: #401D0C;
    padding: 8px 20px 0px;
    margin-left: 0;
    background: #FFFFFF;
}
.title{
    margin-left:20px;
}
.heading {
    display: flex;
    flex-direction: row;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 140%;
    color: #333333;
    margin: 0;
}
.submitBtn {
    background: #2E31BE;
    border-radius: 4px;
    color: #FFFFFF;
    padding: 9.5px 16px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 700;
    border: none;
    height: 40px;
}
.subHeading {
    margin-top: 32px;
    font-size: 16px;
    font-weight: 600;
    line-height: 22.4px;
    text-align: left;
    color: #666666;
}
.onboardingForm {
    display: flex;
    flex-direction: column;
    margin: 1%;
    text-align: start;
    background: #FFFFFF;
    padding: 22px 24px 36px;
    border-radius: 12px;
}
.content{
    height: 100%;
}
.textbox{
    width: 274px;
    padding: 8px 12px;
    font-weight: 400;
    font-size: 12px;
    line-height: 26px;
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    max-width: 246px;
}
.label{
    font-weight: 600;
    font-size: 12px;
    line-height: 17px;
    color: #333333;
    margin-bottom: 12px;
    margin-top: 16px;
}
.role{
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    padding: 8px 14px;
    width: 152px;
    height: 32px;
    font-weight: 400;
    font-size: 12px;
    line-height: 23px;
    color: #41434C;
    opacity: 0.8;
}
.text {
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
}
.formContainer {
    display: flex;
    flex-wrap: wrap;
    max-width: 600px;
    margin-top: 16px;
}
@media (min-width: 850px) {
    .formContainer > div:nth-child(even) {
        margin-left: 32px;
    }
}
.errorHeading{
    font-weight: 700;
    font-size: 14px;
    line-height: 140%;
    color: #EB5757;
    display: flex;
}

.apiErrorMessage{
    font-weight: 400;
    font-size: 12px;
    line-height: 140%;
    color: #666666;
    margin-top: 12px;
}
.countryCode{
    padding: 13px 4px;
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-right: 0px;
    font-size: 12px;
}
.comments {
    padding: 8px 12px;
    font-weight: 400;
    font-size: 12px;
    line-height: 26px;
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    width: 288px;
    height: 118px;
}
.backArrow {
    cursor: pointer;
}
.textbox:disabled {
  background-color: #E0E0E0;
}
</style>
